import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { dictionaryBillingColumns } from '../constants/dictionary-billing-columns.constant';

export const generateBillingSecondColumn = () => {
	return [
	
    {
			title: dictionaryBillingColumns[Enviroment.LANGUAGE].street,
			dataIndex: 'street',
      key: 'street',
      align:'center'
		},
		{
			title: dictionaryBillingColumns[Enviroment.LANGUAGE].street_number,
			dataIndex: 'street_number',
      key: 'street_number',
      align:'center'

		},
    {
			title: dictionaryBillingColumns[Enviroment.LANGUAGE].between_street,
			dataIndex: 'between_street',
      key: 'between_street',
      align:'center'

    },
    {
			title: dictionaryBillingColumns[Enviroment.LANGUAGE].type_house,
			dataIndex: 'type_house',
      key: 'type_house',
      align:'center'

    },
    {
			title: dictionaryBillingColumns[Enviroment.LANGUAGE].number_dpto_house,
			dataIndex: 'number_dpto_house',
      key: 'number_dpto_house',
      align:'center'

		}
    
	];
};
